import React, { useEffect, useState, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints, BeliefShift, CoursePillars, Instructors, VideoShowcase, MarketingVideo, Brands } from './components/Discovery';
import { Benefits, Offer, TargetAudience, Differentiator } from './components/ValueProposition';
import { CourseOrganization, Guarantee, HowItWorks, FAQ, FinalCTA, Testimonials } from './components/TrustAndClosing';
import { Button, InlineCTA, MarqueeBar } from './components/ui';
import { motion, AnimatePresence } from 'framer-motion';
const CHECKOUT_URL = 'https://sistema-iphone-ads.myshopify.com/cart/add?id=46176935641285&quantity=1&return_to=/cart';
export function App() {
  const [showFloatingCTA, setShowFloatingCTA] = useState(false);
  useEffect(() => {
    // Performance: Delay Meta Pixel injection to free up main thread for LCP
    const initPixel = () => {
      const w = window as any;
      if (!w.fbq) {
        const n: any = function (...args: any[]) {
          n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
        };
        w.fbq = n;
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', '2025373898394216');
      w.fbq('track', 'PageView');
    };
    // Wait 2.5 seconds or until browser is idle before loading tracking scripts
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(() => setTimeout(initPixel, 1500));
    } else {
      setTimeout(initPixel, 2500);
    }
    // Performance: Inject preconnect and preload tags dynamically
    // Note: In a real production environment, these should go directly into public/index.html
    const head = document.head;
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://images.unsplash.com';
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://cdn.magicpatterns.com';
    const preloadHero = document.createElement('link');
    preloadHero.rel = 'preload';
    preloadHero.as = 'image';
    preloadHero.href = 'https://cdn.magicpatterns.com/uploads/kCpyyUqtNHfdPP5GuQ1Cpw/2.jpg';
    // @ts-ignore
    preloadHero.fetchPriority = 'high';
    head.appendChild(preconnect1);
    head.appendChild(preconnect2);
    head.appendChild(preloadHero);
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShowFloatingCTA(true);
      } else {
        setShowFloatingCTA(false);
      }
    };
    // Performance: Add passive flag to scroll listener
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen text-zinc-50 font-sans selection:bg-blue-500/30 relative" data-id="element-0">
      {/* Global Premium Background Glows - Hidden on mobile for performance */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden hidden md:block" data-id="element-1">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-blue-600/10 blur-[120px]" data-id="element-2" />
        <div className="absolute top-[40%] right-[-10%] w-[40%] h-[50%] rounded-full bg-violet-600/10 blur-[120px]" data-id="element-3" />
        <div className="absolute bottom-[-10%] left-[10%] w-[50%] h-[50%] rounded-full bg-cyan-600/10 blur-[120px]" data-id="element-4" />
      </div>

      <div className="relative z-10" data-id="element-5">
        <MarqueeBar data-id="element-6" />
        <Hero data-id="element-7" />
        <VideoShowcase data-id="element-8" />
        <Brands data-id="element-9" />
        <PainPoints data-id="element-10" />
        <InlineCTA text="Quiero acceder al curso por $19.000" data-id="element-11" />
        <TargetAudience data-id="element-12" />
        <InlineCTA text="Quiero acceder al curso por $19.000" data-id="element-13" />
        <BeliefShift data-id="element-14" />
        <CoursePillars data-id="element-15" />
        <Instructors data-id="element-16" />
        <MarketingVideo data-id="element-17" />
        <Benefits data-id="element-18" />
        <Offer data-id="element-19" />
        <Testimonials data-id="element-20" />
        <Differentiator data-id="element-21" />
        <CourseOrganization data-id="element-22" />
        <Guarantee data-id="element-23" />
        <HowItWorks data-id="element-24" />
        <FAQ data-id="element-25" />
        <FinalCTA data-id="element-26" />
      </div>

      {/* Floating Mobile CTA */}
      <AnimatePresence data-id="element-27">
        {showFloatingCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-zinc-950/90 backdrop-blur-md border-t border-zinc-800 z-50 md:hidden" data-id="element-28">
            <Button href={CHECKOUT_URL} className="w-full py-4 text-lg shadow-2xl" data-id="element-29">
              Acceder por $19.000
            </Button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}